export const resetPwdErrorInformation: { [id: string]: string } = {
  recoveryTokenVerificationFailed: "Token invalid or expired",
  errorInResettingPassword: "Error in resetting password. Try again later",
};
